import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading, userPrefPageSize } from '@/decorators';
import { OperatingStatus } from '@/enum';
import AddEditShopModal from './components/addEditShopModal.vue';
import BindAccountModal from './components/bindAccountModal.vue';
import UnbindAccountModal from './components/unbindAccountModal.vue';
import ShopLogModal from './components/shopLogModal.vue';

var ShopListPage = function (_super) {
  __extends(ShopListPage, _super);

  function ShopListPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.searchData = _this.initSearchData();
    _this.loadingStatus = false;
    _this.columns = [];
    _this.data = [];
    _this.total = 0;
    _this.bodyList = [];
    _this.currentRecord = {};
    _this.modeState = OperatingStatus.add;
    return _this;
  }

  ShopListPage.prototype.initSearchData = function () {
    return {
      account_code: undefined,
      shop_name: '',
      page_index: 1,
      page_size: 10
    };
  };

  ShopListPage.prototype.handleSearch = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.searchData.page_index = 1;
            return [4, this.queryList()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  ShopListPage.prototype.handleClear = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _this = this;

      return __generator(this, function (_a) {
        this.searchData = this.initSearchData();
        this.$nextTick(function () {
          return _this.queryList();
        });
        return [2];
      });
    });
  };

  ShopListPage.prototype.handlePageChange = function (page, pageSize) {
    this.searchData.page_index = page;
    this.searchData.page_size = pageSize;
    this.queryList();
  };

  ShopListPage.prototype.queryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, resData, _b, _c, list, _d, total;

      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            postData = {
              account_code: this.searchData.account_code,
              shop_name: this.searchData.shop_name,
              page_index: this.searchData.page_index,
              page_size: this.searchData.page_size
            };
            return [4, this.$api.shopManage.queryList(postData)];

          case 1:
            _a = _e.sent().data, resData = _a === void 0 ? {} : _a;
            _b = resData, _c = _b.list, list = _c === void 0 ? [] : _c, _d = _b.total, total = _d === void 0 ? 0 : _d;
            this.data = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  ShopListPage.prototype.queryBodyList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.shopManage.getBodyList({})];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? {
              list: []
            } : _a;
            this.bodyList = data.list || [];
            return [2];
        }
      });
    });
  };

  ShopListPage.prototype.handleAdd = function () {
    this.modeState = OperatingStatus.add;
    this.currentRecord = {};
    var addEditRef = this.$refs.addEditRef;
    addEditRef.visible = true;
  };

  ShopListPage.prototype.handleEdit = function (record) {
    this.modeState = OperatingStatus.edit;
    this.currentRecord = __assign({}, record);
    var addEditRef = this.$refs.addEditRef;
    addEditRef.visible = true;
  };

  ShopListPage.prototype.handleBindAccount = function (record) {
    this.currentRecord = __assign({}, record);
    var bindAccountRef = this.$refs.bindAccountRef;
    bindAccountRef.visible = true;
  };

  ShopListPage.prototype.handleUnbind = function (record) {
    this.currentRecord = __assign({}, record);
    var unbindAccountRef = this.$refs.unbindAccountRef;
    unbindAccountRef.visible = true;
  };

  ShopListPage.prototype.handleDelete = function (record) {
    var _this = this;

    this.$confirm({
      title: this.t('删除店铺'),
      content: this.t('确认删除店铺【{0}】？', [record.shop_name]),
      okType: 'danger',
      okText: this.t('确认删除'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, void 0, function () {
          var code;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4, this.$api.shopManage["delete"]({
                  id: record.id
                })];

              case 1:
                code = _a.sent().code;

                if (code === 0) {
                  this.$message.success(this.t('删除成功'));
                  this.queryList();
                }

                return [2];
            }
          });
        });
      }
    });
  };

  ShopListPage.prototype.handleLog = function (record) {
    this.currentRecord = __assign({}, record);
    var logRef = this.$refs.logRef;
    logRef.visible = true;
  };

  ShopListPage.prototype.handleSuccess = function () {
    this.queryList();
  };

  ShopListPage.prototype.created = function () {
    this.columns = [{
      title: this.t('店铺编码'),
      dataIndex: 'shop_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('客户代码'),
      dataIndex: 'customer_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('店铺名称'),
      dataIndex: 'shop_name',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('绑定主体'),
      dataIndex: 'bind_body',
      scopedSlots: {
        customRender: 'bind_body'
      }
    }, {
      title: this.t('操作'),
      width: 220,
      fixed: 'right',
      key: 'operation',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.queryList();
    this.queryBodyList();
  };

  __decorate([userPrefPageSize('shopManageList')], ShopListPage.prototype, "initSearchData", null);

  __decorate([loading('loadingStatus')], ShopListPage.prototype, "queryList", null);

  ShopListPage = __decorate([Component({
    components: {
      AddEditShopModal: AddEditShopModal,
      BindAccountModal: BindAccountModal,
      UnbindAccountModal: UnbindAccountModal,
      ShopLogModal: ShopLogModal
    }
  })], ShopListPage);
  return ShopListPage;
}(Vue);

export default ShopListPage;